import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
    total: 0,
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getTotal(state) {
      return state.total;
    },
  },
  mutations: {
    setData(state, payload) {
      state.items = payload.items || [];
      state.total = payload.total || 0;
    },
    updateLocalStatus(state, { id, status }) {
      const item = state.items.find(i => i.id === id);
      if (!item) return;
      if ('status_name' in item) item.status_name = status;
      if ('status' in item) item.status = status;
    },
  },
  actions: {
    async fetchEvaluations({ commit }, params) {
      const response = await axios.get("/v1/risk_evaluations", { params });
      const { data, total } = response.data;
      commit("setData", { items: data, total: total });
      return response.data;
    },
    updateLocalStatus({ commit }, payload) {
      commit("updateLocalStatus", payload);
    },
    async deleteEvaluation(_, evaluationId) {
      const { data } = await axios.delete(`/v1/risk_evaluations/${evaluationId}`);
      return data;
    },
    async updateEvaluationtatus(_, { evaluationId, statusName }) {
      const { data } = await axios.post(`/v1/risk_evaluations_update_status/${evaluationId}`, {
        status: statusName,
      });
      return data;
    },
    async createEvaluation(_, payload) {
      const { data } = await axios.post("/v1/risk_evaluations", payload);
      return data;
    },
    async updateEvaluation(_, { evaluationId, payload }) {
      const { data } = await axios.put(`/v1/risk_evaluations/${evaluationId}`, payload);
      return data;
    },
  },
};
